import React from 'react';

class SelectOption extends React.Component {
  buildOption() {
    return (
      <option disabled={this.props.disabled} value={this.props.value}>
        {this.props.displayName}
      </option>
    );
  }

  render() {
    return this.buildOption();
  }
}

export { SelectOption };
